import authRules from '../authRules';

const editDayTypeRequest = (user) => {
  const { status, myComment, statusRemark, deleteDaysOffRequest } = user.securityLevels;
  if (
    status >= authRules.editDayTypeRequest.status
    && myComment >= authRules.editDayTypeRequest.myComment
    && statusRemark >= authRules.editDayTypeRequest.statusRemark
    && deleteDaysOffRequest >= authRules.editDayTypeRequest.deleteDaysOffRequest
    ) {
    return true;
  } else {
    return false;
  }
}


export default editDayTypeRequest;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/editDayTypeRequest.js